module.exports = __webpack_public_path__ + "static/media/LandingPage_Mobile_BackgroundPic.cb100bd6.jpg";